import { createAction, props } from '@ngrx/store';

import { MenuItem } from 'src/app/core/models/main-menu.models';

export const toggleMainMenuExpanded = createAction(
  '[Core] Toggle Main Menu Expanded',
);

export const toggleHeaderExpand = createAction(
  '[Core] Toggle Header Expand',
  props<{ menuItem: MenuItem }>(),
);
